import { Col, Divider, Row, Tooltip } from "antd";
import classNames from "classnames";
import AuthorisedContainer from "components/AuthorisedContainer";
import _ from "lodash";
import React from "react";
import { CellRenderers } from "utils/tableUtils";
import EditIconButton from "components/EditIconButton";


export function FindingDetailsGrid({
  list,
  data,
  itemGapClassName,
  labelWidth,
  gutter = [10, 10],
  valueContainerClassName
}) {
  let _labelWidth = labelWidth;
  if (_.isUndefined(_labelWidth)) {
    _labelWidth = 120;
  }
  
  return (
    <Row gutter={gutter} className="m-b-0">
      {list.map(
        (
          {
            label,
            path,
            span = 8,
            formatter,
            valueClassName,
            containerClassName,
            editAction,
            extra,
            actionPermission,
            featureFlag,
            valueBold = true,
            disableEdit = () => false,
            editButtonToolTip =  "",
            editButtonClassName = "",
            icon,
            name,
            hideDefaultEditAction = false
          },
          i
        ) => {
          const disableEditFlag = disableEdit(data, label);

          const editActionButton = (
            <AuthorisedContainer permission={actionPermission}>
              {disableEditFlag ? (
                <Tooltip title={editButtonToolTip}>
                  <span>
                    <EditIconButton disabled={disableEditFlag} />
                  </span>
                </Tooltip>
              ) : (
                <EditIconButton
                  className={editButtonClassName}
                  onClick={editAction}
                />
              )}
            </AuthorisedContainer>
          );
            
          const value = _.get(data, path.split("."));
          if(path === "subSection"){
            return formatter(value, data)
          }
          if(name && name.includes("header")){
            return (
              <>
                <Divider type="horizontal" />
                <div style={{ marginLeft: 4 }}>
                  <strong>
                    {label}
                  </strong>
                </div>
              </>
            )
          }
          if (featureFlag === false) {
            return null;
          }
          const valueText = path
            ? formatter
              ? formatter(value, data, editActionButton)
              : CellRenderers.VALUE_OR_NA(value)
            : null;
          const labelStyle = {
            ...(containerClassName && containerClassName.includes("flex-column")
              ? {}
              : { width: _labelWidth }),
            minWidth: _labelWidth,
            color: "#999EA7",
            lineHeight: 1.5,
            paddingTop: 3.5,
            fontSize: 12,
            fontWeight: 600,
          };
          return (
            <Col
              key={`${path || label}-${i}`}
              span={span}
              className={classNames(
                "d-flex",
                containerClassName,
                itemGapClassName
                  ? { [itemGapClassName]: i !== list.length - 1 }
                  : {}
              )}
            >
              {label ? (
                <div className="m-r-xs finding-field-label" style={labelStyle}>
                  {label}
                </div>
              ) : null}
              <div className={classNames("d-flex text-ellipsis finding-value-field", valueContainerClassName)}>
                <div
                  title={_.isString(valueText) ? valueText : undefined}
                  className={classNames(
                    "text-ellipsis flex-1",
                    valueClassName,
                    { "text-bold": valueBold }
                  )}
                >
                  {valueText}
                </div>
                {icon ? icon(data) : null}
                {editAction && !hideDefaultEditAction ? (
                 editActionButton
                ) : null}
                {extra || null}
              </div>
            </Col>
          );
        }
      )}
    </Row>
  );
}